// extracted by mini-css-extract-plugin
export default {"list":"List_list__DrYFp","tags":"List_tags__eaygD","list-tit":"List_list-tit__s5q4v","list-description":"List_list-description__lr13t","links-box":"List_links-box__JXzZH"};